import { useCallback, useEffect, useRef, useState, type ReactNode } from 'react';
import { ContextoAvisoBreve, DURACION_AVISO_MS, type AvisoBreve } from './avisoBreve';
import { Icono } from './Icono';

/**
 * Pinta los avisos breves (0.3, «toast»): tarjeta de radio 18 que sube desde abajo, negra si salió bien y roja si falló
 * (con «Reintentar»), 3,2 s. En móvil va por encima de la barra inferior.
 */
export function ProveedorAvisoBreve({ children }: { children: ReactNode }) {
    const [aviso, setAviso] = useState<AvisoBreve | null>(null);
    const [visible, setVisible] = useState(false);
    const temporizador = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const mostrar = useCallback((nuevo: AvisoBreve) => {
        clearTimeout(temporizador.current);
        setAviso(nuevo);
        setVisible(true);
        temporizador.current = setTimeout(() => {
            setVisible(false);
        }, DURACION_AVISO_MS);
    }, []);

    useEffect(() => () => {
        clearTimeout(temporizador.current);
    }, []);

    const tipo = aviso?.tipo ?? 'ok';
    return (
        <ContextoAvisoBreve.Provider value={mostrar}>
            {children}
            <div className={`rv-toast rv-toast--${tipo}${visible ? ' rv-toast--visible' : ''}`} role={tipo === 'error' ? 'alert' : 'status'} aria-hidden={!visible}>
                <Icono nombre={tipo === 'error' ? 'triangle-alert' : 'check'} />
                <span className="rv-toast__texto">{aviso?.texto}</span>
                {aviso?.reintentar !== undefined && (
                    <button
                        type="button"
                        className="rv-toast__boton"
                        onClick={() => {
                            setVisible(false);
                            aviso.reintentar?.();
                        }}
                    >
                        <Icono nombre="refresh-cw" />
                        <span>Reintentar</span>
                    </button>
                )}
            </div>
        </ContextoAvisoBreve.Provider>
    );
}
